import { buildHashForRoute } from "../routing/appRouteState.js";

const primaryTabs = [
  { key: "home", labelKey: "home", href: "#/home", end: false },
  { key: "expenses", labelKey: "expenses", href: "#/expenses", end: false },
  { key: "analysis", labelKey: "analysis", href: "#/analysis", end: false },
  { key: "budget", labelKey: "budget", href: "#/budget", end: false },
  { key: "settings", labelKey: "settings", href: "#/settings", end: true },
  { key: "help", labelKey: "help", href: "#/help", end: false }
];

export function buildHeaderTabs(currentSections, t) {
  return primaryTabs.map((tab) => {
    const translatedTab = {
      ...tab,
      label: t(tab.labelKey)
    };

    if (tab.key === "analysis") {
      return {
        ...translatedTab,
        href: buildHashForRoute("analysis", currentSections)
      };
    }

    if (tab.key === "settings") {
      return {
        ...translatedTab,
        href: buildHashForRoute("settings", currentSections)
      };
    }

    if (tab.key === "help") {
      return {
        ...translatedTab,
        href: buildHashForRoute("help", currentSections)
      };
    }

    return translatedTab;
  });
}

export function buildHeaderAlert({ updateAvailable, backupNeedsAttention, t }) {
  if (updateAvailable) {
    return {
      label: t("refresh"),
      icon: "refresh",
      onClick: () => window.location.reload()
    };
  }

  if (backupNeedsAttention) {
    return {
      label: t("alert"),
      icon: "alert",
      href: "#/settings/backup"
    };
  }

  return null;
}
